<template>
  <div class="container">
    <div class="newresult">
      <template v-if="codeType == 1 || codeType == 2 || codeType == 3">
        <div class="newresult-book" v-if="bookInfo">
          <div class="newresult-book-box">
            <div class="newresult-book-left">
                <img
                    :src="
                    bookInfo.Cover == ''
                        ? 'https://c.cdn.quyixian.com/nocover.png'
                        : bookInfo.Cover
                    "
                    alt=""
                />
            </div>
            <div class="newresult-book-right">
              <div class="newresult-book-content">
                <h1 class="bookName" v-if="bookInfo.NickName">
                  {{ bookInfo.NickName }}
                </h1>
                <h1 class="title" v-else>{{ bookInfo.Name }}</h1>
                <div class="bookContent">
                  <p>
                    <span>版本：</span><em>{{ bookInfo.Banben }}</em>
                  </p>
                  <p>
                    <span>书号：</span><em>{{ bookInfo.BookNumber }}</em>
                  </p>
                  <p>
                    <span>开本：</span><em>{{ bookInfo.Folio }}</em>
                  </p>
                  <p>
                    <span>定价：</span
                    ><em v-if="bookInfo.Pricing">{{ bookInfo.Pricing }}元</em>
                  </p>
                  <p>
                    <span>出版社：</span><em v-html="bookInfo.Publishing"></em>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="result_box">
          <template v-if="codeType == 1 || codeCount == 0">
            <div class="title_first">
                <h1 class="title">此图书首次被验证！</h1>
                <div class="content">
                    <p class="p_text">
                        首次查询时间：
                        <span class="text">
                            {{$moment(firstTime).format("YYYY-MM-DD HH:mm")}}
                        </span>
                    </p>
                    <p class="p_text">首次查询地址：<span class="text">{{ firstAddress || map.address }}</span></p>
                </div>
                <!-- <div class="pic2"></div> -->
            </div>
          </template>
          <template v-else>
            <template v-if="isPirate == 1">
                <div class="title_second">
                    <div class="title">
                        <div class="pic3">
                            <img src="../../assets/imgs/warn_icon.png" alt="">
                        </div>
                        <div>此图书为盗版图书！</div>
                    </div>
                    <div class="warn_count">该书已被验证{{ codeCount }}次！</div>
                    <!-- <div class="content" v-html="codeInfo.Info"></div> -->
                    <div class="warn_content">
                        请与我公司客服联系（电话：400-898-5353）凡提供相关线索一经查实，我公司将给予<span class="sty_size">正版图书及现金奖励</span>!
                    </div>
                    <div class="warn_btn">
                        <div>您还可以点击按钮：</div>
                        <div class="btn" @click="toReport">去举报</div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="title_first">
                    <h1 class="title1" :class="{'title_normal': codeCount >= 10}">
                        <template v-if="codeCount >= 10">
                            <i>警告：</i>
                        </template>
                        此图书已被验证{{ codeCount }}次！
                    </h1>
                    <template v-if="isPirate == 0 && codeCount >= 10">
                        <p class="warn_text">该防伪码查询次数过多，谨防假冒！</p>
                    </template>
                    <div class="content">
                        <p class="p_text">
                            首次查询时间：
                            <span class="text">
                                {{$moment(firstTime).format("YYYY-MM-DD HH:mm")}}
                            </span>
                        </p>
                        <p class="p_text">首次查询地址：<span class="text">{{ firstAddress || map.address }}</span></p>
                    </div>
                    <div class="pic2"></div>
                </div>
            </template>
          </template>
        </div>
      </template>
      <template v-else>
        <div class="title_third">
            <div class="title_first ">
                <h1 class="title">您所查询的图书可能是盗版图书</h1>
                <div class="content">
                    <p>
                    盗版图书可能存在危害身体健康、图书内容有误等情况，无法提供高质量的图书内容。建议您举报盗版，并通过官方渠道购买正版图书。
                    </p>
                </div>
            </div>
        </div>
      </template>
      <template v-if="bookInfo.Stage == '高中' || bookInfo.Stage == '初中'">
        <div class="spacial_box" @click="toUrl">
            <img class="spacial_pic" src="../../assets/imgs/banner2.jpg" alt="">
        </div>
      </template>
      <div class="special_explain">
        <div class="title_text">特别说明</div>
        <img src="../../assets/imgs/message.png" alt="">
      </div>
      <div class="spacial_content">
        <div class="content_left">
            <img src="../../assets/imgs/erweima.png" alt="">
        </div>
        <div class="content_right">正版图书的验证二维码码会采用喷印工艺，用手触摸二维码会有凹凸不平的感觉。</div>
      </div>
      <div class="spacial_content">
        <div class="content_left">
            <img src="../../assets/imgs/tiaoma.png" alt="">
        </div>
        <div class="content_right">使用激光笔照射正版图书封面或书脊，会显示和封底二维码下方的身份码相同的数字。</div>
      </div>
      <div class="spacial_content">
        <div class="content_left">
            <img src="../../assets/imgs/yanzhengma.png" alt="">
        </div>
        <div class="content_right">正版图书验证码为一书一码，且每本图书均有唯一的13位身份码及4位验证码。</div>
      </div>

      <div class="newresult-vs">
        <router-link :to="'/cont'"
          ><img src="../../assets/imgs/banner1.png" alt=""
        /></router-link>
      </div>
    </div>
    <!-- 悬浮跳转 -->
    <div class="jump_box" v-if="bookInfo.Stage == '高中' || bookInfo.Stage == '初中'" @click="toUrl"></div>
    <div class="qyx">北京曲一线图书策划有限公司</div>
  </div>
</template>

<script>
import qs from "qs";
import { Toast, Dialog } from "vant";
export default {
  name: "Result",
  data() {
    return {
      loading: false,
      code: this.$route.query.code || sessionStorage.getItem("code"), //码
      verify: this.$route.params.verify || sessionStorage.getItem("codeMessage"), //验证码
      source: this.$route.params.source, //来源
      bookInfo: this.$route.params.bookInfo || JSON.parse(sessionStorage.getItem("bookInfo"))  || {}, //图书信息
      codeInfo: this.$route.params.codeInfo || JSON.parse(sessionStorage.getItem("codeInfo"))  || {}, //码信息
      codeType:this.$route.params.codeType || sessionStorage.getItem("codeType") || 4, //类型  1多次 2首次 3未采集或未入库出库信息  4没查到
      ip: this.$route.params.ip,
      map: JSON.parse(sessionStorage.getItem("addr")), //定位信息
      //sohu: returnCitySN, //搜狐定位
      isPirate: 0, //是否提示盗版信息来源后台 默认0关闭
      codeCount: 0, //查询次数
      firstTime: "", //首次时间
      firstAddress: "", //首次地址
      currentAddress: "", //当前地址
      currentTime: new Date(), //当前时间

      // userinfo: JSON.parse(sessionStorage.getItem("userinfo")),
      // token: "",
    };
  },
  mounted() {
    if (this.ip == null || this.ip == "") {
      fetch("https://api.ipify.org?format=json")
        .then((x) => x.json())
        .then(({ ip }) => {
          this.ip = ip;
        });
    }
    // this.token = { Authorization: "Bearer " + this.userinfo.token };

    if (this.codeInfo != null) {
      let { FirstTime, FirstAddress, Count, IsPirate, Info } = this.codeInfo;
      this.isPirate = IsPirate;
      this.firstTime = FirstTime;
      this.firstAddress = FirstAddress;
      if (Count && Count > 0) {
        this.codeCount = Count + 1;
      }
    }
    if (this.map && this.map.province != null) {
      this.currentAddress =
        this.map.address == null ? this.map.province : this.map.address;
      //console.log(this.currentAddress);
    }

    if (this.bookInfo != null) {
      let pub = this.bookInfo.Publishing;
      if (pub) {
        this.bookInfo.Publishing = pub.replace(/  /, "<br/>");
      }
    }

    //延时保存记录;
    let that = this;
    setTimeout(function () {
      if (that.map && (that.map.address == null || that.map.province == null)) {
        Dialog.alert({
          title: "拒绝查询",
          message: "获取位置信息异常！",
          confirmButtonText: "返回",
        }).then(() => {
          that.$router.push({ path: "/", query: { id: that.code } });
        });
        return false;
      } else {
        that.SaveUser();
      }
    }, 1000);
  },
  methods: {
    SaveUser() {
      let task = null,
        taskpress = null,
        book = null,
        code2 = null;
      if (this.codeInfo != null) {
        if (this.codeInfo.TaskId) {
          task = this.codeInfo.TaskId;
        }
        if (this.codeInfo.TaskId) {
          taskpress = this.codeInfo.TaskPressId;
        }
        if (this.codeInfo.BookId) {
          book = this.codeInfo.BookId;
        }
        if (this.codeInfo.Code2) {
          code2 = this.codeInfo.Code2;
        }
      }
      let info = "";
      if (this.map && this.map.province != null) {
        info =
          "province:" +
          this.map.province +
          ",city:" +
          this.map.city +
          ",district:" +
          this.map.district +
          ",lat:" +
          this.map.lat +
          ",lng:" +
          this.map.lng;
      }
      let params = {
        CodeType: this.codeType,
        Code1: this.code,
        VerifyCode: this.verify,
        TaskId: task,
        TaskPressId: taskpress,
        BookId: book,
        Code2: code2,
        Source: this.source,
        //
        IP: this.ip,
        Address: this.map != null ? this.map.address : "",
        Province: this.map != null ? this.map.province : "",
        City: this.map != null ? this.map.city : "",
        District: this.map != null ? this.map.district : "",
        Info: info,
      };
      this.$api.code
        .SaveUserInfo(qs.stringify(params), this.token)
        .then((res) => {
          let { Data, Tag, Message } = res;
          if (Tag == 1) {
            //console.log(params);
          } else {
            this.$dialog.alert({
              title: "错误",
              message: Message,
            });
          }
        });
    },

    formatStr(str) {
      str = str.replace(/\r\n/gi, "<br/>");
      return str;
    },

    toReport(){
        this.$router.replace({ path: "/pirate", query: { code: this.code } });
    },

    toUrl(){
        window.location.href = 'https://work.weixin.qq.com/kfid/kfcfbb1284a2c938585';
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.newresult {
  padding: 0 0.3rem;
  background-color: #f5f5f5;
  &-book {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    // margin-top: 10px;
    // margin: 0.3rem 0;
    // margin-bottom: .6rem;
    // background-color: pink;
    &-title {
      width: 2.94rem;
      height: 0.74rem;
      margin-bottom: 0.3rem;
    }
    &-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      margin-bottom: 41px;
    }

    &-left {
    //   max-width: 2.7rem;
    //   max-height: 4.02rem;
      width: 112px;
      height: 159px;
      img {
        width: 100%;
      }
    }
    &-right {
    //   flex: 1;
      width: 4.34rem;
    //   height: 4.28rem;
    //   background: url("https://c.cdn.quyixian.com/front/2023/bookinfo0bg1.png")
    //     no-repeat;
    //   background-size: 100%, 100%;
    }

    &-content {
      margin: 0.3rem;
      padding-left: 0.1rem;

      .bookName {
        font-size: 18px;
        font-weight: 600;
        line-height: 1.6;
        margin: 0.15rem 0;
        overflow: hidden; /* 隐藏超出部分 */
        display: -webkit-box; /* 使用-webkit-box布局 */
        -webkit-line-clamp: 2; /* 设置最多显示两行 */
        -webkit-box-orient: vertical; /* 设置盒模型的方向为垂直 */
        text-overflow: ellipsis; /* 超出部分用省略号表示 */
      }
      .bookContent {
        font-size: 14px;

        p {
          line-height: 1.9;
        //   display: flex;
        //   justify-content: flex-start;
        //   align-items: center;
        }
        span {
          width: 1rem;
          text-align: right;
        }
      }
    }
  }
  &-fruit {
    width: 100%;
    height: 242px;
    background-color: rgba(254, 119, 33, 1);
    border-radius: 0.3rem;
    margin-bottom: 45px;
    padding: 0 10px;
    box-sizing: border-box;
    & > h1 {
      font-size: 0.46rem;
    }
  }
  .result_box{
    background: rgba(254, 119, 33, 1);
    padding: 0 10px;
    box-sizing: border-box;
    border-radius: 7.74px;
    margin-bottom: 40px;
    .title_first{
        width: 100%;
        min-height: 200px;
        // height: 255px;
        // background-color: #fff;
        border-radius: 7.74px;
        opacity: 1;
        box-shadow: 0px 2px 4px  rgba(0, 0, 0, 0.25);
        transform: translateY(-14px);
        margin-top: 20px;
        background: url('../../../src/assets/imgs/bg2.png') no-repeat;
        background-size: 100% 100%;
        // position: absolute;
        // top: -26px;
        // left: 9px;
        .title {
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 28px;
            color: rgba(252, 88, 43, 1);
            text-align: center;
            padding: 26px 40px;
            box-sizing: border-box;
        }
        .title1{
            font-size: 20px;
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 28px;
            color: rgba(56, 56, 56, 1);
            text-align: center;
            padding: 25px 20px 5px 20px;
            box-sizing: border-box;
        }
        .title_normal{
            padding: 26px 40px 5px 40px;
            box-sizing: border-box;
        }
        .warn_text{
            font-size: 16px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 32px;
            color: rgba(252, 88, 43, 1);
            text-align: center;
            margin-bottom: 18px;
        }
        .content {
            font-size: 16px;
            font-weight: 700;
            letter-spacing: 0px;
            color: rgba(51, 51, 51, 1);
            padding-left: 16px;
            padding-right: 19px;
            padding-bottom: 28px;
            box-sizing: border-box;
            .p_text{
                margin-bottom: 8px;
                .text{
                    // width: 100px;
                    font-weight: normal;
                    font-size: 16px;
                    // display: inline-block;
                }
            }
            
        }
        // .pic2{
        //     width: 110px;
        //     height: 110px;
        //     background: url('../../../src/assets/imgs/bg1.png') no-repeat;
        //     background-size: 100% 100%;
        //     border-radius: 7.74px;
        //     position: absolute;
        //     bottom: 0;
        //     right: 0;
        //     z-index: 1;
        // }
    }
  }
  .title_second{
        border-radius: 9.51px;
        background: rgba(254, 119, 33, 1);
        padding: 30px 2px 18px 10px;
        box-sizing: border-box;
        overflow: hidden;
        .title{
            font-size: 28px;
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 28px;
            color: rgba(255, 255, 255, 1);
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 13px;
            .pic3{
                margin-right: 9px;
                width: 36px;
                height: 36px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .warn_count{
            font-size: 20px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 32px;
            text-decoration-line: underline;
            color: rgba(242, 242, 242, 1);
            text-align: center;
            margin-bottom: 17px;
        }
        .warn_content{
            font-size: 15px;
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 32px;
            color: rgba(255, 255, 255, 1);
            margin-bottom: 20px;
            .sty_size{
                font-size: 18px;
                text-decoration-line: underline;
            }
        }
        .warn_btn{
            font-size: 16px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 32px;
            color: rgba(255, 255, 255, 1);
            display: flex;
            float: right;
            .btn{
                border-radius: 8px;
                background: rgba(94, 178, 99, 1);
                font-size: 16px;
                font-weight: 700;
                letter-spacing: 0px;
                color: rgba(255, 255, 255, 1);
                padding: 0 15px;
            }
        }
    }
  .title_third{
    height: 228px;
    margin-top: 1rem;
    border-radius: 7.4px;
    background: rgba(254, 119, 33, 1);
    margin-bottom: 40px;
    .title_first{
        height: 238px;
        transform: translateY(-24px);
        margin: 0 10px 0;
        background-color: #fff;
        border-radius: 7.4px;
        .title {
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 28px;
            color: rgba(252, 88, 43, 1);
            text-align: center;
            padding: 26px 40px;
            box-sizing: border-box;
        }
        .content {
            padding: 0 8px;
            font-size: 15px;
            font-weight: 700;
            letter-spacing: 0px;
            color: rgba(51, 51, 51, 1);
        }
    }
  }
  .special_explain{
        display: flex;
        align-items: center;
        margin-bottom: 28px;
        .title_text{
            font-size: 24px;
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 34.75px;
            color: rgba(56, 56, 56, 1);
        }
        img{
            width: 24px;
            height: 24px;
            display: inline-block;
            margin-left: 10px;
        }
  }
  .spacial_content{
    display: flex;
    border-radius: 10px;
    margin-bottom: 29px;
    background-color: #fff;
    .content_left{
        width: 118px;
        height: 115px;
        img{
            width: 100%;
            height: 100%;
            border-radius: 10px 0 0 10px;
        }
    }
    .content_right{
        width: calc(100% - 118px);
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 32px;
        color: rgba(51, 51, 51, 1);
        text-align: left;
        padding: 10px;
        margin-left: 20px;
        background-color: #fff;
    }
  }
  &-steal {
    display: flex;
    margin-bottom: 0.3rem;
    box-shadow: 0 0 6px rgba($color: #000000, $alpha: 0.1);
    img {
      width: 100%;
    }
  }
  &-explain {
    display: flex;
    justify-content: space-around;
    padding: 0.6rem 0;
    align-items: flex-start;

    &-line {
      border-right: 2px dashed #5795e0;
      border-left: 2px dashed #5795e0;
    }

    &-box {
      width: 30%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 0.15rem;

      h6 {
        color: #ff8450;
        font-size: 0.28rem;
      }

      img {
        width: 1.3rem;
        height: 1.3rem;
      }
      p {
        font-size: 0.24rem;
        line-height: 2;
      }
    }
  }
  &-vs {
    margin: 0.3rem 0;

    img {
      width: 100%;
    }
  }
}

.jump_box{
    width: 100px;
    height: 50px;
    position: fixed;
    top: 215px;
    right: 0px;
    background: url('../../assets/imgs/jump.gif') no-repeat;
    background-size: 100% 100%;
}
.spacial_box{
    margin-bottom: 40px;
    .spacial_pic{
        width: 100%;
        height: 100%;
        border-radius: 7.4px;
    }
}
.qyx {
  text-align: center;
  font-size: 0.28rem;
  color: rgba(115, 148, 204, 1);
  padding: 0.3rem;
  background-color: rgba(245, 245, 245, 1);
}
</style>
